import React from 'react';
import {Header, Footer, HowItWorks as HWContent} from '../components/components'

const HowItWorks = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header/>
      <div className="flex-1 mt-[64px] flex items-center bg-[#ACACAC1F]">
        <div className="w-full">
          <HWContent/>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default HowItWorks;
